const nameSorter = employer => employer.name.toLowerCase()

angular.module('app.api').factory('CandidateProfileApi', [
  'api',
  'userService',
  '$rootScope',
  function CandidateProfileApi(api, userService, $rootScope) {
    const candidateProfileAPi = {
      followEmployer: async (userId, employerId) => {
        return api.post(`users/${userId}/follow/${employerId}`)
      },
      unFollowEmployer: async (userId, employerId) => {
        return api.delete(`users/${userId}/follow/${employerId}`)
      },
      getUserProfile: async (id, payload) => {
        return api.get(`users/${id}/profile`, {
          params: payload,
        })
      },
      getUserFollowEmployers: async id => {
        return api.get(`users/${id}/follow`)
      },
      getUserHiddenEmployers: async id => {
        return api.get(`users/${id}/hidden`)
      },
      getUserBlockedEmployers: async id => {
        return api.get(`users/${id}/blocked`)
      },
      updateUserBlockedEmployers: async (id, payload) => {
        return api.put(`users/${id}/blocked`, payload)
      },
      getUserResumes: async id => {
        return api.get(`users/${id}/profile/resumes`)
      },
      getResume: async id => {
        return api.get(`resumes/${id}`)
      },
      deleteUserResume: async (id, resumeId) => {
        return api.delete(`users/${id}/profile/resume`, {params: {resumeId}})
      },
      updateUserResumeName: async (id, parameters) => {
        return api.put(
          `users/${id}/profile/resume/name`,
          {},
          {params: parameters}
        )
      },
      getLoginHistory: async id => {
        return api.get(`actions?category=user&target=${id}`)
      },
      unHideEmployer: async (userId, employerId) => {
        return api.delete(`users/${userId}/hidden/${employerId}`)
      },
      getEmailSubscriptions: async userId => {
        return api.get(`users/${userId}/subscriptions`)
      },

      pauseEmail: async (userId, emailType, noOfDays) => {
        const payload = {
          days: noOfDays ? noOfDays : 30,
        }
        return api.put(
          `users/${userId}/subscriptions/${emailType}/pause`,
          payload
        )
      },
      unpauseEmail: async (userId, emailType) => {
        return api.put(`users/${userId}/subscriptions/${emailType}/unpause`)
      },
      subscribe: async (userId, emailType) => {
        return api.post(`users/${userId}/subscriptions/${emailType}`)
      },
      unsubscribe: async (userId, emailType) => {
        return api.delete(`users/${userId}/subscriptions/${emailType}`)
      },
      uploadResume: async (userId, file) => {
        return api.post(`users/${userId}/profile/resume`, file, {
          headers: {'Content-Type': undefined},
        })
      },
      uploadProfilePhoto: async (userId, file) => {
        return api.post(`users/${userId}/profile/photo`, file, {
          headers: {'Content-Type': undefined},
        })
      },
      deleteProfilePhoto: async userId => {
        return api.delete(`users/${userId}/profile/photo`)
      },
      getExperiences: async userId => {
        return api.get(`users/${userId}/experience`)
      },
      getEmployersList: async () => {
        const unsorted = await api.get(`employers?include=id&include=name`)

        return {
          config: unsorted.config,
          headers: unsorted.headers,
          status: unsorted.status,
          statusText: unsorted.statusText,
          xhrStatus: unsorted.xhrStatus,
          data: _.sortBy(unsorted.data, nameSorter),
        }
      },
      getCandidateList: async () => {
        return api.get(`users/candidates`)
      },
      updateUserData: async (id, payload) => {
        const user = await userService.getUser()

        const updatedUser = await api.put(`users/${id}`, payload)

        // Update data in local storage for header too

        if (updatedUser.data.id === user.id) {
          await userService.setUser(updatedUser.data)
          $rootScope.user = updatedUser.data
        }

        return updatedUser
      },
      updateProfileData: async (id, payload) => {
        console.debug(`updateProfileData(${id})`, payload)
        return api.put(`users/${id}/profile`, payload)
      },
      getAdminAndCorporateUsers: async () => {
        return api.get(`users?role=admin&role=corporate&isArchived=false`)
      },
      getUserSettings: async id => {
        return api.get(`users/${id}/settings`)
      },
      updateUserSettings: async (userId, settingId, enable) => {
        return api.put(`users/${userId}/setting/${settingId}?enable=${enable}`)
      },
      getLastConversation: async userId => {
        return api.get(`users/${userId}/agent/last-conversation`)
      },
      updateCandidateApprovalStatus: (userId, payload) => {
        return api.put(`users/${userId}/approval-status`, payload)
      },
    }
    return candidateProfileAPi
  },
])



// WEBPACK FOOTER //
// ./scripts/lawyer-profile/candidate-profile.api.js